module.exports = __webpack_public_path__ + "static/images/containers/WGCWXLeaderboards/components/RewardTooltip/images/medal_veteran.1d85b81a.png";


//////////////////
// WEBPACK FOOTER
// ./containers/WGCWXLeaderboards/components/RewardTooltip/images/medal_veteran.png
// module id = 1389
// module chunks = 11